import Api from 'services/Api';
import ParserRestApi from 'helpers/ParserRestApi';

let currentAjax = {};
const fetchAll = (params, reducer, url) => {
	return (dispatch) => {
		dispatch({
			type: reducer.FETCHING_ALL,
		});
		if (
			typeof currentAjax[reducer.GET_ALL] !== 'undefined' &&
			typeof currentAjax[reducer.GET_ALL].cancel === 'function'
		) {
			currentAjax[reducer.GET_ALL].cancel();
		}
		currentAjax[reducer.GET_ALL] = Api.get(
			params,
			url + '/',
			(error, data) => {
				if (error) {
					return dispatch({
						type: reducer.ERROR_ALL,
						payload: {
							message: data,
						},
					});
				}
				return dispatch({
					type: reducer.GET_ALL,
					payload: ParserRestApi.parse(data)
				});
			}
		);
	};
};
export default fetchAll;
